export const CATEGORY_SPORT_PRODUCT = [
  {
    title: "ВСЁ",
    // type:'all',
  },

  {
    title: "СКАКАЛКИ",
    type: "jumprope",
  },

  {
    title: "РЕЗИНКИ, ЖГУТЫ",
    type: "elasticbands",
  },
  {
    title: "СПОРТИВНЫЕ ТОВАРЫ",
    type: "sporting",
  },
  {
    title: "МЯЧИ",
    type: "balls",
  },
  {
    title: "РОЛИКИ",
    type: "roller",
  },
  {
    title: "ВОДНЫЙ СПОРТ",
    type: "watersport",
  },

  {
    title: "SUP-ДОСКИ",
    type: "supboard",
  },
];
